// Ctrl+Z：調整舞台有兩種「改動」——
//   草稿（機關位置、動作時間；按「存回」才存，退回是退草稿，AdjustStore.undo）
//   已經存進後台的 cue 操作（拖 cue 換順序 / 對調、拖 cue 編號改時間、拉轉場；放開就存，退回 = 再打一次反向的後台呼叫）
// 這裡放後者的退回堆疊，和「這一下 Ctrl+Z 退哪一種」的判斷（誰比較新退誰）。不靠 React，有測試。

export interface OpsEntry {
  label: string;
  /** 做的時間（跟草稿倉庫的 lastEditAt 同一個時鐘：performance.now） */
  at: number;
  /** 退回；失敗要丟錯（畫面講白話） */
  undo: () => Promise<void>;
}

const MAX_OPS = 30;

export class OpsUndoStack {
  private list: OpsEntry[] = [];
  private listeners = new Set<() => void>();

  constructor(private readonly now: () => number = () => performance.now()) {}

  subscribe = (fn: () => void): (() => void) => { this.listeners.add(fn); return () => { this.listeners.delete(fn); }; };
  private emit() { for (const l of [...this.listeners]) l(); }

  push(label: string, undo: () => Promise<void>) {
    this.list.push({ label, undo, at: this.now() });
    if (this.list.length > MAX_OPS) this.list.shift();
    this.emit();
  }
  /** 換歌 / 換頁：前一首的操作不能在這裡退 */
  clear() { if (this.list.length) { this.list = []; this.emit(); } }
  canUndo(): boolean { return this.list.length > 0; }
  lastAt(): number { return this.list.length ? this.list[this.list.length - 1].at : -Infinity; }
  lastLabel(): string | null { return this.list.length ? this.list[this.list.length - 1].label : null; }

  /** 退回最後一個；成功回它的名字，沒有 → null。失敗：這個操作還留在堆疊上，錯誤丟出去 */
  async undo(): Promise<string | null> {
    const e = this.list[this.list.length - 1];
    if (!e) return null;
    await e.undo();
    this.list = this.list.filter(x => x !== e);
    this.emit();
    return e.label;
  }
}

/** 這一下 Ctrl+Z 退哪一種：兩邊都有 → 誰比較新退誰；只有一邊有 → 那邊；都沒有 → null */
export function whichUndo(o: { draftCan: boolean; draftAt: number; opsCan: boolean; opsAt: number }): 'draft' | 'ops' | null {
  if (o.draftCan && o.opsCan) return o.opsAt > o.draftAt ? 'ops' : 'draft';
  if (o.draftCan) return 'draft';
  if (o.opsCan) return 'ops';
  return null;
}
